import {useTranslation} from 'react-i18next';
import {InboxOutlined} from '@ant-design/icons';
import {Space, theme, Typography, Upload, UploadFile} from 'antd';
import type {UploadRequestOption} from 'rc-upload/lib/interface';
import {FileDto} from '../../../../PRMGApiClient';
import {Spinner} from './ui/Spinner';

interface AttachmentsDropzoneProps {
  attachments: Array<FileDto>;
  addAttachments: (files: File[]) => void;
  removeAttachment: (fileId: number) => void;
  isLoading: boolean;
}

export const AttachmentsDropzone: React.FunctionComponent<AttachmentsDropzoneProps> = ({
  attachments,
  addAttachments,
  removeAttachment,
  isLoading,
}) => {
  const {t} = useTranslation();
  const {token} = theme.useToken();

  return (
    <>
      {isLoading && (
        <div className="absolute top-0 left-0 w-full h-full bg-white opacity-50 z-10 flex justify-center items-center skip-fade">
          <Spinner />
        </div>
      )}
      <Space direction="vertical" className="w-full">
        <Upload.Dragger
          name="file"
          customRequest={(options: UploadRequestOption) => addAttachments([options.file as File])}
          fileList={
            attachments.map((item) => ({
              uid: item.fileId?.toString(),
              name: item.fileName,
              status: 'done',
              url: item.url,
            })) as UploadFile<unknown>[]
          }
          multiple={true}
          onRemove={(file) => removeAttachment(Number(file.uid))}
        >
          <Space direction="vertical" className="m-4">
            <InboxOutlined style={{color: token.blue, fontSize: token.fontSizeHeading1}} />
            <Typography.Text>{t('Click or drag file to this area to upload')}</Typography.Text>
          </Space>
        </Upload.Dragger>
      </Space>
    </>
  );
};
